import { DELIVERY_OPTIONS } from "../constants/DeliveryConstants";

/**
 * The three groups the orders page can be narrowed to (client request 2026-10-16): VCE Landelijk,
 * VCE Regionaal and HVO. Every order falls in exactly one of them, so "Alle" is always the sum.
 *
 * | Group         | Orders                                                                    |
 * |---------------|---------------------------------------------------------------------------|
 * | HVO           | every Halalvlees Online order (HVO has no pickups and no regional customers) |
 * | VCE Regionaal | VCE send orders to West-Friesland (`landelijk === false`) and VCE pickups  |
 * | VCE Landelijk | every other VCE order: send orders with `landelijk === true` or unknown   |
 *
 * Pickups count as regional, like the "Regionaal" print menu (`getRegionaalOrders`). An order
 * without a `landelijk` field counts as national, like `isLandelijk` in region.js: unknown is
 * landelijk until it is known.
 *
 * Pure: no Firestore, no React.
 */

export const ORDER_GROUP_ALL = "all";
export const ORDER_GROUP_VCE_LANDELIJK = "vce_landelijk";
export const ORDER_GROUP_VCE_REGIONAAL = "vce_regionaal";
export const ORDER_GROUP_HVO = "hvo";

/** In the order the filter shows them. */
export const ORDER_GROUPS = [ORDER_GROUP_VCE_LANDELIJK, ORDER_GROUP_VCE_REGIONAAL, ORDER_GROUP_HVO];

export const orderGroupOf = (order) => {
  if (order?.shopSource === "HVO") return ORDER_GROUP_HVO;
  if (order?.delivery?.type === DELIVERY_OPTIONS.PICKUP || order?.landelijk === false) return ORDER_GROUP_VCE_REGIONAAL;
  return ORDER_GROUP_VCE_LANDELIJK;
};

export const isInOrderGroup = (order, group) => !group || group === ORDER_GROUP_ALL || orderGroupOf(order) === group;

/** `{ all, vce_landelijk, vce_regionaal, hvo }`: how many orders each filter option would show. */
export const countOrderGroups = (orders) =>
  (orders || []).reduce(
    (counts, order) => {
      counts[orderGroupOf(order)] += 1;
      counts[ORDER_GROUP_ALL] += 1;
      return counts;
    },
    { [ORDER_GROUP_ALL]: 0, [ORDER_GROUP_VCE_LANDELIJK]: 0, [ORDER_GROUP_VCE_REGIONAAL]: 0, [ORDER_GROUP_HVO]: 0 },
  );
